export default function StatusMessage({ status }) {
  if (!status?.message) {
    return null
  }

  return (
    <div className={`status-message status-message--${status.type}`} role="status">
      {status.message}
    </div>
  )
}
